import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10 mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Nome Serviço:", -1)
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Código Peça:", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Preço Peça:", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Código Mão de Obra:", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Código Mão de Obra Fora do Pacote:", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Tempo Mão de Obra:", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Preço Mão de Obra:", -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Descrição/Vídeo/Imagem:", -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Exibir Pacote Fabrica:")
], -1)
const _hoisted_25 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)

import {
  Installment,
  ItemPackageDetailView,
  ItemDescription,
} from "@/models/CardapioModel";
import { reactive, watch, onMounted, ref, nextTick } from "vue";
import { itemDescription, updatePackageItem } from "@/services/CardapioService";
import { useStore } from "vuex";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import Swal from "sweetalert2/dist/sweetalert2.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormPackageItem',
  props: {
    updatePackageItem: {}
  },
  setup(__props: any) {

const props = __props;

const optionItemDescription = ref<ItemDescription[]>([]);
const form = reactive({
  servico: "",
  codigoPeca: "",
  precoPeca: "",
  codigoMaoObra: "",
  codigoMaoObraAlacarte: "",
  tempoMaoObra: 0,
  valorMaoObra: "",
  dadosExtra: 0,
  podedesmarcar: 0,
});

const ruleFormRef = ref();
const emitter = useEmitter();
const store = useStore();
const { showTimeAlert } = useAlert();
const concessionariaSelected = localStorage.getItem("filtroConcessionaria");
const loading = reactive({
  submit: false,
  optionDescription: false,
});

const money = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  precision: 2,
};

const time = {
  decimal: ".",
  thousands: ".",
  precision: 1,
};

onMounted(() => {
  getItemDescription();
});

const rules = reactive({
  servico: [
    {
      required: true,
      message: "Por favor, preencha. O preenchimento é obrigatório.",
      trigger: "blur",
    },
  ],
  precoPeca: [
    {
      required: true,
      message: "Por favor, preencha. O preenchimento é obrigatório.",
      trigger: "blur",
    },
  ],
});

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      Swal.fire({
        title: "Deseja fazer alterações no item?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        text: "As alterações serão refletidas no app assim que forem salvas.",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else if (result.isDenied) {
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

watch(
  () => props.updatePackageItem,
  (newValue) => {
    if (newValue) {
      form.servico = newValue.servico;
      form.codigoMaoObraAlacarte = newValue.codigoMaoObraAlacarte;
      form.codigoPeca = newValue.codigoPeca;
      form.dadosExtra = newValue.dadosExtra;
      form.podedesmarcar = newValue.podedesmarcar;
      form.servico = newValue.servico;
      form.tempoMaoObra = Number(newValue.tempoMaoObra);
      form.codigoMaoObra = newValue.codigoMaoObra;

      nextTick(() => {
        form.precoPeca = newValue.precoPeca;
        form.valorMaoObra = newValue.valorMaoObra;
      });
    }
  },
  { deep: true, immediate: true }
);

const handleSubmit = async () => {
  if (concessionariaSelected && typeof concessionariaSelected == "string") {
    const payload = {
      ...form,
      precoPeca: form.precoPeca.replace("R$", "").trim(),
      valorMaoObra: form.valorMaoObra.replace("R$", "").trim(),
      codAgregados: props.updatePackageItem.codAgregados,
      codConcessionaria: concessionariaSelected,
    };

    loading.submit = true;
    await updatePackageItem(payload)
      .then((r) => {
        showTimeAlert(r.message);
        emitter.emit("update-family", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => (loading.submit = false));
  }
};

const getItemDescription = async () => {
  loading.optionDescription = true;
  optionItemDescription.value = await itemDescription();
  loading.optionDescription = false;
};


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_money = _resolveDirective("money")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: form,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "auto",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_form_item, { prop: "servico" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.servico,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.servico) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, { prop: "codigoPeca" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "Digite um código",
                    modelValue: form.codigoPeca,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.codigoPeca) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_form_item, { prop: "precoPeca" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: form.precoPeca,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.precoPeca) = $event))
                  }, null, 8, ["modelValue"]), [
                    [_directive_money, money]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "codigoMaoObra" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "Digite um código",
                    modelValue: form.codigoMaoObra,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.codigoMaoObra) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_el_form_item, { prop: "codigoMaoObraAlacarte" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "Digite um código",
                    modelValue: form.codigoMaoObraAlacarte,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.codigoMaoObraAlacarte) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_form_item, { prop: "codigoMaoObra" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: form.tempoMaoObra,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.tempoMaoObra) = $event))
                  }, null, 8, ["modelValue"]), [
                    [_directive_money, time]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_el_form_item, { prop: "valorMaoObra" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: form.valorMaoObra,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.valorMaoObra) = $event))
                  }, null, 8, ["modelValue"]), [
                    [_directive_money, money]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_el_form_item, { prop: "parcelaPadrao" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha uma parcela",
                    modelValue: form.dadosExtra,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.dadosExtra) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionItemDescription.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codPersonalizacao,
                          label: item.nomePersonalizacao,
                          value: item.codPersonalizacao
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])), [
                    [_directive_loading, loading.optionDescription]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_el_switch, {
                style: {"text-align":"right","margin-left":"15px"},
                modelValue: form.podedesmarcar,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.podedesmarcar) = $event)),
                "inactive-color": "#ff4949",
                "active-color": "#13ce66",
                "active-value": 1,
                "inactive-value": 0,
                "active-text": "Sim",
                "inactive-text": "Não"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm background_btn_1 text-white",
              id: "kt_button_1",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm(ruleFormRef.value))),
              disabled: loading.submit
            }, [
              (!loading.submit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode(" Salvar ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _hoisted_30,
                    _createTextVNode(" Aguarde... ")
                  ]))
            ], 8, _hoisted_26)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})